<capacitor-google-map id="map" role="img" #map></capacitor-google-map>